<template>
	<div>
		<AddFieldModal ref="fieldModal" v-model="form" v-on:updateFieldList="updateFieldList"/>
		<FieldList ref="fieldList" v-model="form" v-on:editField="editFieldEvent"/>
	</div>
</template>

<script>
	import FieldList from "./FieldList";
	import AddFieldModal from "./AddFieldModal";

	export default {
		name: "FieldPanel",
		components: {FieldList, AddFieldModal},

		props: {
			value: Object,
		},

		methods: {
			editFieldEvent(editedFieldIndexes) {
				this.$refs.fieldModal.editField(editedFieldIndexes);
			},
			updateFieldList() {
				this.$refs.fieldList.updateFieldList();
			},
		},

		watch: {
			form: {
				handler() {
					this.$emit("input", this.form);
				}
				,
				deep: true,
			},
		},

		data() {
			return {
				form: this.value,
			};
		},
	};
</script>
<style scoped>

</style>
